const TYPE = `[ERROR]`;

export default {
  ERROR: `${TYPE} ERROR`,
  INFO: `${TYPE} INFO`,
  WARN: `${TYPE} WARN`,
  LOG: `${TYPE} LOG`,
  DISMISS: `${TYPE} DISMISS`,
};
